// tenantStore.js
import { API_SERVICE } from "@/services/api.service";

export default {
    namespaced: true,
    state: {
        activeTenant: null
    },
    mutations: {
        SET_ACTIVE_TENANT(state, data) {
            state.activeTenant = data;
        }
    },
    getters: {
        // Base getter for active tenant
        activeTenant: state => state.activeTenant || null,

        // Tenant basic information
        tenantName: (state, getters) => getters.activeTenant?.TenantName || '',
        tenancyAddress: (state, getters) => getters.activeTenant?.TenancyAddress || '',
        
        // Tenancy details
        tenancyDetails: (state, getters) => getters.activeTenant?.TenancyDetails || {},
        tenancyCard: (state, getters) => getters.tenancyDetails?.TenancyCard || {},
        
        // Managing agent
        managingAgent: (state, getters) => getters.activeTenant?.ManagingAgent || {},
        
        // Insights
        insights: (state, getters) => getters.activeTenant?.Insights || [],
        
        // Certificates
        certificates: (state, getters) => getters.activeTenant?.Certificates || [],
        
        // Documents
        documents: (state, getters) => getters.activeTenant?.Documents || {},
        documentArrayOne: (state, getters) => getters.documents?.DocArrayOne || [],
        documentArrayTwo: (state, getters) => getters.documents?.DocArrayTwo || [],
        
        // Maintenance
        maintenanceJobs: (state, getters) => getters.activeTenant?.MaintenanceJobs || [],
        
        // Maintenance work items
        maintenanceWorkItems: (state, getters) =>  getters.activeTenant?.MaintenanceWorkItems || [] ,

        // Appointments
        appointments: (state, getters) => getters.activeTenant?.Appointments || [],
        
        // Upload related
        tenantOID: (state, getters) => getters.activeTenant?.OID || null,
        tenancyOID: (state, getters) => getters.tenancyCard?.OID || null,
        
        // Upload options computed getter
        uploadToOptions: (state, getters) => {
            const options = [];
            
            if (getters.tenantOID) {
                options.push({
                    Label: 'Tenant account (private)',
                    OID: getters.tenantOID
                });
            }
            
            if (getters.tenancyOID) {
                options.push({
                    Label: 'Tenancy Documents (viewable to landlord)',
                    OID: getters.tenancyOID
                });
            }
            
            return options;
        }
    },
    actions: {
        getActiveTenant({ commit }, payload) {
            const params = {
                body: {
                    clientName: payload.clientName,
                    tenantID: payload.tenantID
                }
            };
            
            return new Promise((resolve, reject) => {
                API_SERVICE.post("peoplePortalRestAPI", "/accounts/tenant/active", params)
                    .then((response) => {
                        if (response.status === "200") {
                            commit("SET_ACTIVE_TENANT", response.data);
                            resolve({
                                success: true,
                                data: response.data
                            });
                        } else {
                            commit("SET_ACTIVE_TENANT", null);
                            reject({
                                success: false,
                                error: response.error
                            });
                        }
                    })
                    .catch((error) => {
                        commit("SET_ACTIVE_TENANT", null);
                        reject({
                            success: false,
                            error: error.message
                        });
                    });
            });
        }
    }
}